import type libJquery from 'jquery';

// ----------------------------------------------------------------------------

type TypeGlobalJquery = typeof globalThis & {
    $?: typeof libJquery;
    jQuery?: typeof libJquery;
};

// ----------------------------------------------------------------------------

let jquery: typeof libJquery | undefined;

// ----------------------------------------------------------------------------

function resolveGlobalJquery(): typeof libJquery | undefined {
    const globalObject = globalThis as TypeGlobalJquery;

    return globalObject.jQuery ?? globalObject.$;
}

function setJquery(ex: typeof libJquery): void {
    if (jquery && jquery !== ex) {
        console.warn('jQuery has already been initialized');
    }

    jquery = ex;
}

function getJquery(): typeof libJquery {
    jquery ??= resolveGlobalJquery();

    if (!jquery) {
        throw new Error('Operation requires jQuery. Ensure it is loaded before use.');
    }

    return jquery;
}

function hasJquery(): boolean {
    return jquery != null || resolveGlobalJquery() != null;
}

// ----------------------------------------------------------------------------

export { getJquery, hasJquery, setJquery };
